import React, { useEffect, useRef }  from 'react';
import './webchat/MinimizableWebChat.scss';
import classNames from 'classnames';
import wavingAvatar from './assets/videos/BOTaina_waving.mp4';

export const Loading = () => {

return <>
<div className='minimizable-web-chat'>
    <div
      className={classNames(
        'chat-box ',
        'intro'
      )}>
        <div className={`info-steps`}>
            <video   width="296" height="296" autoPlay loop muted playsInline >
                <source src={wavingAvatar} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
            <div className="info-steps__text">
                <p>{'Hey there,'}</p>
                <p>{"I'm Botaina."}</p>
            </div>
            
            <div className='info-steps__bottom'>
                <h2 style={{ color: '#000' }}>{ 'Loading...' }</h2>
            </div>
        </div>
    </div>
</div>
<div className={`web-chat-background active`}></div>
</>
};
